import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Layout, Form, Icon, Input, Button, Divider, message } from 'antd'
import authService from '../services/authentication.service'
import { UserContext } from '../contexts/UserContext'

const { Header } = Layout

class JoinUsForgotPasswordForm extends React.Component {
  state = {
    isPasswordReset: false,
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const res = await authService.forgotJoinUsPassword(values.username)
        if (res) {
          message.success(
            'Please check your inbox for an email to reset your password'
          )
          this.setState({ isPasswordReset: true })
        }
      }
    })
  }

  render() {
    const { isPasswordReset } = this.state
    const { getFieldDecorator } = this.props.form

    if (isPasswordReset) return <Redirect to="/joinus/login" />

    return (
      <Form onSubmit={this.handleSubmit} className="login-form register-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: '#FFF' }} />}
              placeholder="Username"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="large"
            shape="round"
            block={true}
            htmlType="submit"
            className="login-form-button"
            style={{ marginTop: '-6rem' }}
          >
            Reset Password
          </Button>
          <Link to="/joinus/login">
            <p className="cta-link" style={{ textAlign: 'center' }}>
              Back to Login Page
            </p>
          </Link>
        </Form.Item>
      </Form>
    )
  }
}

const WrappedJoinUsForgotPasswordForm = Form.create({
  name: 'joinus_forgot_password',
})(JoinUsForgotPasswordForm)

const JoinUsForgotPassword = () => {
  return (
    <Layout>
      <section id="login-page">
        <Header className="header">
          <div className="header__logo" />
        </Header>
        <content>
          <section id="login-content">
            <div className="cta">
              <h1>Forgot Password</h1>
              <h3>
                Please enter your email to<br></br>reset your password
              </h3>
            </div>
            <Divider type="vertical" />
            <div className="login-form-container registration-form-container">
              <WrappedJoinUsForgotPasswordForm />
            </div>
          </section>
        </content>
      </section>
    </Layout>
  )
}

JoinUsForgotPassword.contextType = UserContext

export default JoinUsForgotPassword
